import { clsx } from 'clsx';
import { CSSProperties, PropsWithChildren } from 'react';
import { Radio as AriaRadio } from 'react-aria-components';
import Text from '~/components/typographies/Text';
import useDataTestId from '~/hooks/useDataTestId';
import styles from './Radio.module.scss';

interface Props {
  className?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  otherInfo?: string;
  strong?: boolean;
  style?: CSSProperties;
  value: string;
  dataTestId?: string;
}

const Radio: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
  isDisabled,
  isInvalid,
  otherInfo,
  strong,
  style,
  value,
  dataTestId,
}) => {
  const dt = useDataTestId(dataTestId);
  return (
    <AriaRadio
      className={clsx(
        styles.control,
        {
          [styles.strong!]: strong,
          [styles.invalid!]: isInvalid,
          [styles.withOtherInfo!]: otherInfo,
        },
        className,
      )}
      isDisabled={isDisabled}
      value={value}
      style={style}
      data-testid={dt()}
    >
      <div className={styles.indicatorContainer}>
        <div className={styles.indicator}></div>
      </div>
      {children}
      {otherInfo && (
        <Text variant="caption" weight="medium" secondaryColor className={styles.otherInfo}>
          {otherInfo}
        </Text>
      )}
    </AriaRadio>
  );
};

export default Radio;
